// Fix ActionCable's stale connection detection
// The default implementation had false positives

export function disableStaleDetection(consumer) {
  if (!consumer || !consumer.connection || !consumer.connection.monitor) return consumer;
  
  const monitor = consumer.connection.monitor;
  
  // Fix reconnectIfStale to check actual connection state
  const originalReconnectIfStale = monitor.reconnectIfStale?.bind(monitor);
  monitor.reconnectIfStale = function() {
    const wsState = this.connection.webSocket?.readyState;
    
    // Only reconnect if WebSocket is actually closed or closing
    if (wsState === 2 || wsState === 3) {
      console.log('🔄 Connection needs reconnection (WebSocket state:', wsState, ')');
      this.connection.reopen();
    } else if (wsState === 1) {
      // Connection is fine, just ensure ActionCable knows it
      this.recordConnect();
    }
  };
  
  // Fix isStale to check actual WebSocket state
  monitor.isStale = function() {
    const wsState = this.connection.webSocket?.readyState;
    // Stale if WebSocket is closing (2) or closed (3)
    return wsState === 2 || wsState === 3;
  };
  
  // Set reasonable thresholds
  monitor.staleThreshold = 10; // seconds - reasonable for detecting actual disconnections
  monitor.reconnectAttempts = 0;
  
  // Let the monitor continue but with fixed logic
  const originalStartPolling = monitor.start?.bind(monitor);
  monitor.start = function() {
    if (originalStartPolling) {
      originalStartPolling();
      console.log('✅ ActionCable monitor started with fixed stale detection');
    }
  };
  
  console.log('✅ ActionCable stale detection FIXED');
  return consumer;
}